import {iosBookUserHttp} from './index'

function iosUserRequest(url, method, data) {
    return iosBookUserHttp({
        url: url,
        method: method,
        data: data
    })
}

function get(url, data) {
    return iosUserRequest(url, 'get', data)
}

function post(url, data) {
    return iosUserRequest(url, 'post', data)
}

export function shopItemStockBook() {
    return get('/shopping/current/stock')
}

export function searchUser(data) {
    return post('/cat/admin/search', data)
}

export function searchOrder(data) {
    return post('/shopping/admin/record', data)
}

export function getUser(data) {
    return post('/user/get/' + data)
}

export function bind(data) {
    return post('/user/bind1/' + data)
}

export function unbind(id, type) {
    return post('/user/unbind/' + id + "/" + type)
}

export function queryCoin(data) {
    return post('/user/coin/' + data)
}

export function trans(from, to) {
    return post('/user/trans/' + from + "/" + to)
}

export function addCoin(id, coin) {
    return post('/user/coin/add/' + id + "/" + coin)
}

export function vip(nickId, vipType, vip, event, account) {
    return post('/user/vip/' + nickId + "/" + vipType + "/" + vip + "/" + event + "/" + account)
}

export function searchBill(opaId) {
    return post('/user/searchBill' , opaId)
}

export function searchLedger(data) {
    return post('/user/searchLedger' , data)
}

export function updateLedger(data) {
    return post('/user/updateLedger' , data)
}

export function searchAssert(data) {
    return post('/user/searchAssert' , data)
}

export function updateAssert(data) {
    return post('/user/updateAssert' , data)
}